/* Pushes GTM dataLayer events for Shopify Forms (app) submissions.
   The Forms widget is a React app inside <shopify-forms-embed>'s open shadow
   root and exposes no public submit event, so we watch the shadow DOM:
   - "shopify_form_submit"  -> user attempted a submit
   - "shopify_form_success" -> the form was replaced by the success view
   Use shopify_form_success as the conversion trigger in GTM. */
(function () {
  "use strict";

  function push(eventName, host) {
    var block = host.closest('[id*="shopify-block"]');
    /* the app block renders a root div carrying the Forms app form id,
       e.g. data-forms-id="forms-root-1116078" */
    var rootEl = block ? block.querySelector("[data-forms-id]") : null;
    var formId = rootEl ? (rootEl.getAttribute("data-forms-id") || "").replace("forms-root-", "") : "";
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      form_id: formId,
      form_location: window.location.pathname,
      form_block: block ? block.id : (host.id || "shopify-forms-embed")
    });
  }

  function hook(host) {
    if (host.__stcGtmHooked) return;
    var sr = host.shadowRoot;
    if (!sr) {
      host.__stcGtmTries = (host.__stcGtmTries || 0) + 1;
      if (host.__stcGtmTries < 40) setTimeout(function () { hook(host); }, 500);
      return;
    }
    host.__stcGtmHooked = true;

    var submittedForm = null;

    sr.addEventListener("submit", function (e) {
      submittedForm = e.target;
      push("shopify_form_submit", host);
    }, true);

    var mo = new MutationObserver(function () {
      if (submittedForm && !submittedForm.isConnected) {
        submittedForm = null;
        push("shopify_form_success", host);
      }
    });
    mo.observe(sr, { childList: true, subtree: true });
  }

  function scan() {
    document.querySelectorAll("shopify-forms-embed").forEach(hook);
  }

  var scheduled = false;
  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; scan(); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }
  /* the Forms loader mounts the widget asynchronously — keep watching */
  new MutationObserver(scheduleScan).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- Calendly inline widget: booking confirmed ----------
     Calendly iframes postMessage lifecycle events to the parent page;
     "calendly.event_scheduled" fires when the invitee books a slot. */
  window.addEventListener("message", function (e) {
    if (e.origin.indexOf("https://calendly.com") !== 0) return;
    if (!e.data || e.data.event !== "calendly.event_scheduled") return;

    /* identify which widget on the page sent it */
    var calendlyUrl = "";
    var iframes = document.querySelectorAll(".calendly-inline-widget iframe, iframe[src*='calendly.com']");
    for (var i = 0; i < iframes.length; i++) {
      if (iframes[i].contentWindow === e.source) {
        var wrap = iframes[i].closest(".calendly-inline-widget");
        calendlyUrl = (wrap && wrap.getAttribute("data-url")) || iframes[i].src.split("?")[0];
        break;
      }
    }

    var payload = e.data.payload || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "calendly_event_scheduled",
      calendly_url: calendlyUrl,
      calendly_event_uri: (payload.event && payload.event.uri) || "",
      calendly_invitee_uri: (payload.invitee && payload.invitee.uri) || "",
      form_location: window.location.pathname
    });
  });
})();
